var __vueify_style_dispose__ = require("vueify/lib/insert-css").insert(".ac-loading[data-v-2870a3dd] {\n  text-align: center;\n  padding: 40px;\n  color: #667085;\n}\n\n/* Wallet list items: interactive states */\n.ac-wallet-list-item[data-v-2870a3dd] {\n  transition: transform 0.18s ease, box-shadow 0.18s ease,\n    background-color 0.22s ease, border-color 0.22s ease;\n  will-change: transform;\n}\n.ac-wallet-list-item[data-v-2870a3dd]:hover:not(.ac-wallet-list-item--active) {\n  transform: translateX(5px);\n  box-shadow: 2px 3px 10px rgba(0, 84, 166, 0.1);\n}\n\n/* Right panel: whole content swaps together */\n.wallet-switch-enter-active[data-v-2870a3dd] {\n  transition: opacity 0.32s ease,\n    transform 0.38s cubic-bezier(0.34, 1.4, 0.64, 1);\n}\n.wallet-switch-leave-active[data-v-2870a3dd] {\n  transition: opacity 0.16s ease, transform 0.16s ease;\n}\n.wallet-switch-enter[data-v-2870a3dd] {\n  opacity: 0;\n  transform: translateY(18px) scale(0.985);\n}\n.wallet-switch-leave-to[data-v-2870a3dd] {\n  opacity: 0;\n  transform: translateY(-10px) scale(0.99);\n}")
;(function(){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = require("babel-runtime/core-js/object/assign");

var _assign2 = _interopRequireDefault(_assign);

var _WalletCard = require("./WalletCard.vue");

var _WalletCard2 = _interopRequireDefault(_WalletCard);

var _DateRangePicker = require("./DateRangePicker.vue");

var _DateRangePicker2 = _interopRequireDefault(_DateRangePicker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: ["agent", "wallets", "wallet_types_to_show"],
  components: {
    WalletCard: _WalletCard2.default,
    DateRangePicker: _DateRangePicker2.default
  },
  data: function data() {
    return {
      selectedWalletId: null,
      currentAgent: null,
      transactions: [],
      transactionsLoading: false,
      currentPage: 1,
      pageSize: 10,
      totalPages: 1,
      exportLoading: false,
      dateRange: null,
      walletSearch: "",
      transactionSearch: ""
    };
  },
  mounted: function mounted() {
    if (this.agent) {
      this.currentAgent = JSON.parse(this.agent);
    }

    if (this.typeFilteredWallets.length > 0) {
      this.selectedWalletId = this.typeFilteredWallets[0].id;
    }
  },

  computed: {
    sixMonthsAgo: function sixMonthsAgo() {
      var d = new Date();
      d.setMonth(d.getMonth() - 6);
      return d;
    },
    today: function today() {
      return new Date();
    },
    allowedWalletTypes: function allowedWalletTypes() {
      var raw = this.wallet_types_to_show;

      if (!raw || Array.isArray(raw) && raw.length === 0) return ["all"];

      var list = Array.isArray(raw) ? raw : String(raw).split(",");

      return list.map(function (t) {
        return String(t).trim().toLowerCase();
      }).filter(function (t) {
        return t.length > 0;
      });
    },
    typeFilteredWallets: function typeFilteredWallets() {
      var allowed = this.allowedWalletTypes;

      if (allowed.indexOf("all") !== -1) {
        return this.wallets;
      }

      return this.wallets.filter(function (w) {
        return w.type && allowed.indexOf(String(w.type).toLowerCase()) !== -1;
      });
    },
    filteredWallets: function filteredWallets() {
      var query = this.walletSearch.trim().toLowerCase();
      var base = this.typeFilteredWallets;

      if (!query) return base;

      return base.filter(function (w) {
        return w.currency && w.currency.toLowerCase().includes(query) || w.account_number && w.account_number.toLowerCase().includes(query);
      });
    },
    selectedWallet: function selectedWallet() {
      var id = this.selectedWalletId;
      return this.typeFilteredWallets.find(function (w) {
        return w.id === id;
      }) || null;
    },
    canViewTransactions: function canViewTransactions() {
      return this.selectedWallet && this.selectedWallet.permission && this.selectedWallet.permission.can_view_transactions;
    }
  },
  watch: {
    selectedWalletId: function selectedWalletId(newWalletId) {
      if (newWalletId && this.canViewTransactions) {
        this.loadTransactions(newWalletId);
      } else {
        this.transactions = [];
      }
    }
  },
  methods: {
    formatBalance: function formatBalance(balance) {
      return parseFloat(balance || 0).toLocaleString(undefined, {
        maximumFractionDigits: 0
      });
    },
    canViewBalance: function canViewBalance(wallet) {
      return !!(wallet && wallet.permission && wallet.permission.can_view_balance);
    },
    exportCSV: async function exportCSV() {
      if (!this.selectedWalletId) return;
      this.exportLoading = true;

      try {
        var params = {
          account_id: this.selectedWalletId,
          page: this.currentPage,
          page_size: this.pageSize,
          export: true
        };

        if (this.dateRange && this.dateRange.length === 2) {
          params.start_date = this.dateRange[0] + " 00:00:00";
          params.end_date = this.dateRange[1] + " 23:59:59";
        } else {
          var yesterday = new Date();
          yesterday.setDate(yesterday.getDate() - 1);
          params.start_date = this.toDateParam(yesterday) + " 00:00:00";
          params.end_date = this.toDateParam(new Date()) + " 23:59:59";
        }

        if (this.transactionSearch && this.transactionSearch.trim()) {
          params.q = this.transactionSearch.trim();
        }

        var response = await Vue.axios.get("/api/account-summary-csv", {
          params: params,
          responseType: "blob"
        });

        var disposition = response.headers["content-disposition"] || "";
        var match = disposition.match(/filename="?([^"]+)"?/);
        var filename = match ? match[1] : "account_summary.csv";

        var url = window.URL.createObjectURL(new Blob([response.data]));
        var link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error("CSV export failed:", error);
      } finally {
        this.exportLoading = false;
      }
    },
    handleSelectWallet: function handleSelectWallet(wallet_id) {
      this.selectedWalletId = wallet_id;
    },
    nextPage: function nextPage() {
      if (this.currentPage < this.totalPages) {
        this.loadTransactions(this.selectedWalletId, this.currentPage + 1);
      }
    },
    prevPage: function prevPage() {
      if (this.currentPage > 1) {
        this.loadTransactions(this.selectedWalletId, this.currentPage - 1);
      }
    },
    onPageSizeChange: function onPageSizeChange(event) {
      this.pageSize = parseInt(event.target.value);
      this.currentPage = 1;
      this.loadTransactions(this.selectedWalletId, 1);
    },
    onDateConfirm: function onDateConfirm() {
      this.currentPage = 1;
      this.loadTransactions(this.selectedWalletId, 1);
    },
    onDateClear: function onDateClear() {
      this.dateRange = null;
      this.currentPage = 1;
      this.loadTransactions(this.selectedWalletId, 1);
    },
    onTransactionSearch: function onTransactionSearch() {
      this.currentPage = 1;
      this.loadTransactions(this.selectedWalletId, 1);
    },
    handleTopUp: function handleTopUp(data) {
      this.$emit("top-up", {
        amount: data.amount,
        account_id: data.wallet_id,
        agent: this.currentAgent,
        currency: data.currency
      });
    },
    handlePayInvoice: function handlePayInvoice(data) {
      this.$emit("pay-invoice", data);
    },
    initWithdrawal: function initWithdrawal(data) {
      this.$emit("withdraw", {
        walletId: data.walletId,
        currency: data.currency
      });
    },
    toDateParam: function toDateParam(date) {
      var year = date.getFullYear();
      var month = String(date.getMonth() + 1).padStart(2, "0");
      var day = String(date.getDate()).padStart(2, "0");
      return year + "-" + month + "-" + day;
    },
    loadTransactions: async function loadTransactions(walletId, page) {
      if (!walletId) return;
      this.transactionsLoading = true;
      var self = this;
      var p = page || self.currentPage;

      try {
        var params = {
          account_id: walletId,
          page: p,
          page_size: self.pageSize
        };

        if (self.dateRange && self.dateRange.length === 2) {
          params.start_date = self.dateRange[0] + " 00:00:00";
          params.end_date = self.dateRange[1] + " 23:59:59";
        } else {
          var yesterday = new Date();
          yesterday.setDate(yesterday.getDate() - 1);
          params.start_date = self.toDateParam(yesterday) + " 00:00:00";
          params.end_date = self.toDateParam(new Date()) + " 23:59:59";
        }

        if (self.transactionSearch && self.transactionSearch.trim()) {
          params.q = self.transactionSearch.trim();
        }
        var response = await Vue.axios.get("/api/account-trxns", {
          params: params
        });
        var account = response.data.account || {};

        var moneyIn = account.money_in && account.money_in.data || [];
        var moneyOut = account.money_out && account.money_out.data || [];

        var inMapped = moneyIn.map(function (t) {
          return (0, _assign2.default)({}, t, { direction: "money_in" });
        });

        var outMapped = moneyOut.map(function (t) {
          return (0, _assign2.default)({}, t, { direction: "money_out" });
        });

        self.transactions = inMapped.concat(outMapped).sort(function (a, b) {
          return new Date(b.trx_date) - new Date(a.trx_date);
        });
        var inPages = account.money_in && account.money_in.total_pages || 1;
        var outPages = account.money_out && account.money_out.total_pages || 1;
        self.totalPages = Math.max(inPages, outPages);
        self.currentPage = p;
      } catch (error) {
        console.error("Error loading transactions:", error);
        self.transactions = [];
      } finally {
        self.transactionsLoading = false;
      }
    },
    onItemBeforeEnter: function onItemBeforeEnter(el) {
      el.style.opacity = 0;
      el.style.transform = "translateX(-16px) scale(0.96)";
    },
    onItemEnter: function onItemEnter(el, done) {
      var delay = (parseInt(el.dataset.index) || 0) * 65;
      setTimeout(function () {
        el.style.transition = "opacity 0.4s ease, transform 0.5s cubic-bezier(0.34, 1.56, 0.64, 1)";
        el.style.opacity = 1;
        el.style.transform = "translateX(0) scale(1)";
        el.addEventListener("transitionend", done, { once: true });
      }, delay);
    },
    onItemLeave: function onItemLeave(el, done) {
      el.style.transition = "opacity 0.2s ease, transform 0.2s ease";
      el.style.opacity = 0;
      el.style.transform = "translateX(-10px)";
      el.addEventListener("transitionend", done, { once: true });
    },
    formatDate: function formatDate(dateString) {
      var date = new Date(dateString);

      var day = String(date.getDate()).padStart(2, "0");
      var month = String(date.getMonth() + 1).padStart(2, "0");
      var year = date.getFullYear();

      var hours = date.getHours();
      var minutes = String(date.getMinutes()).padStart(2, "0");

      var period = hours >= 12 ? "PM" : "AM";
      hours = hours % 12 || 12;

      return day + "/" + month + "/" + year + " " + hours + ":" + minutes + " " + period;
    }
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ac-page"},[_c('div',{staticClass:"ac-page-header mb-0"},[_c('h1',{staticClass:"ac-page-title"},[_vm._v("List of wallets")]),_vm._v(" "),_c('a',{staticClass:"ac-cancel-link",on:{"click":function($event){$event.preventDefault();return _vm.$emit('log_out')}}},[_vm._v("\n      Cancel\n      "),_c('svg',{attrs:{"width":"26","height":"26","viewBox":"0 0 26 26","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('rect',{attrs:{"x":"26","y":"26","width":"26","height":"26","rx":"13","transform":"rotate(-180 26 26)","fill":"#F9FAFB"}}),_vm._v(" "),_c('path',{attrs:{"d":"M6.58366 13L19.417 13M13.0003 20L19.417 13L13.0003 6","stroke":"#898989","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])])]),_vm._v(" "),_c('div',{staticClass:"ac-wallet-layout",staticStyle:{"min-height":"calc(100vh - 67px)"}},[_c('div',{staticClass:"ac-wallet-sidebar pt-4"},[_c('h2',{staticClass:"ac-sidebar-title"},[_vm._v("List of wallets")]),_vm._v(" "),_c('div',{staticClass:"ac-sidebar-search"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.walletSearch),expression:"walletSearch"}],staticClass:"ac-sidebar-search-input !border-none",attrs:{"type":"text","placeholder":"Search"},domProps:{"value":(_vm.walletSearch)},on:{"input":function($event){if($event.target.composing){ return; }_vm.walletSearch=$event.target.value}}}),_vm._v(" "),_c('span',{staticClass:"ac-sidebar-search-icon"},[_c('svg',{attrs:{"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M7.66634 13.9997C11.1641 13.9997 13.9997 11.1641 13.9997 7.66634C13.9997 4.16854 11.1641 1.33301 7.66634 1.33301C4.16854 1.33301 1.33301 4.16854 1.33301 7.66634C1.33301 11.1641 4.16854 13.9997 7.66634 13.9997Z","stroke":"#909090","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_vm._v(" "),_c('path',{attrs:{"d":"M14.6663 14.6663L13.333 13.333","stroke":"#909090","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])])]),_vm._v(" "),_c('transition-group',{staticClass:"ac-wallet-list",attrs:{"name":"wallet-list","tag":"div","appear":"","css":false},on:{"before-enter":_vm.onItemBeforeEnter,"enter":_vm.onItemEnter,"leave":_vm.onItemLeave}},_vm._l((_vm.filteredWallets),function(wallet,index){return _c('div',{key:wallet.id,staticClass:"ac-wallet-list-item",class:{
            'ac-wallet-list-item--active': _vm.selectedWalletId === wallet.id,
          },attrs:{"data-index":index},on:{"click":function($event){return _vm.handleSelectWallet(wallet.id)}}},[_c('div',{staticClass:"ac-wallet-list-account"},[_vm._v("\n            A/C "+_vm._s(wallet.account_number)+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"ac-wallet-list-balance",class:{ 'ac-balance-blurred': !_vm.canViewBalance(wallet) }},[_vm._v("\n            "+_vm._s(wallet.currency)+" "+_vm._s(_vm.formatBalance(wallet.balance))+"\n          ")])])}),0)],1),_vm._v(" "),_c('div',{staticClass:"ac-wallet-main pt-4"},[_c('transition',{attrs:{"name":"wallet-switch","mode":"out-in"}},[_c('div',{key:_vm.selectedWalletId || 'empty',staticClass:"wallet-main-inner"},[(_vm.selectedWallet)?_c('WalletCard',{attrs:{"wallet":_vm.selectedWallet,"isActive":true,"layout":"banner"},on:{"top-up":_vm.handleTopUp,"pay-invoice":_vm.handlePayInvoice,"withdraw":_vm.initWithdrawal}}):_vm._e(),_vm._v(" "),_c('h2',{staticClass:"ac-section-title"},[_vm._v("Transactions")]),_vm._v(" "),(_vm.transactionsLoading)?_c('div',{staticClass:"ac-loading"},[_vm._v("\n            Loading transactions...\n          ")]):(!_vm.canViewTransactions)?_c('div',{staticClass:"ac-permission-notice"},[_vm._v("\n            You don't have permission to view transactions for this wallet.\n          ")]):_c('div',{staticClass:"ac-table-wrap"},[_c('div',{staticClass:"ac-table-toolbar"},[_c('div',{staticClass:"ac-search-wrap"},[_c('span',{staticClass:"ac-search-icon"},[_c('svg',{attrs:{"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M17.5 17.5L14.5834 14.5833M16.6667 9.58333C16.6667 13.4954 13.4954 16.6667 9.58333 16.6667C5.67132 16.6667 2.5 13.4954 2.5 9.58333C2.5 5.67132 5.67132 2.5 9.58333 2.5C13.4954 2.5 16.6667 5.67132 16.6667 9.58333Z","stroke":"#667085","stroke-width":"1.66667","stroke-linecap":"round","stroke-linejoin":"round"}})])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.transactionSearch),expression:"transactionSearch"}],staticClass:"ac-search-input",attrs:{"type":"text","placeholder":"Search"},domProps:{"value":(_vm.transactionSearch)},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.onTransactionSearch.apply(null, arguments)},"input":function($event){if($event.target.composing){ return; }_vm.transactionSearch=$event.target.value}}})]),_vm._v(" "),_c('date-range-picker',{attrs:{"icon-only":"","not-before":_vm.sixMonthsAgo,"not-after":_vm.today},on:{"confirm":_vm.onDateConfirm,"clear":_vm.onDateClear},model:{value:(_vm.dateRange),callback:function ($$v) {_vm.dateRange=$$v},expression:"dateRange"}}),_vm._v(" "),(_vm.dateRange && _vm.dateRange.length === 2)?_c('button',{staticClass:"ac-btn-outline",attrs:{"disabled":_vm.exportLoading},on:{"click":_vm.exportCSV}},[_vm._v("\n                "+_vm._s(_vm.exportLoading ? "Exporting..." : "")+"\n                "),_c('svg',{attrs:{"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M13.3337 14.1667L10.0003 17.5L6.66699 14.1667M10.0003 17.5V10M16.667 13.9524C17.6849 13.1117 18.3337 11.8399 18.3337 10.4167C18.3337 7.88536 16.2816 5.83333 13.7503 5.83333C13.5682 5.83333 13.3979 5.73833 13.3054 5.58145C12.2187 3.73736 10.2124 2.5 7.91699 2.5C4.46521 2.5 1.66699 5.29822 1.66699 8.75C1.66699 10.4718 2.3632 12.0309 3.48945 13.1613","stroke":"#667085","stroke-width":"1.66667","stroke-linecap":"round","stroke-linejoin":"round"}})])]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"ac-table-scroll"},[_c('table',{staticClass:"ac-table"},[_c('thead',[_c('tr',[_c('th',[_vm._v("Date")]),_vm._v(" "),_c('th',[_vm._v("Transaction Ref")]),_vm._v(" "),_c('th',[_vm._v("Amount Paid")]),_vm._v(" "),_c('th',[_vm._v("Type")]),_vm._v(" "),_c('th')])]),_vm._v(" "),_c('tbody',_vm._l((_vm.transactions),function(transaction){return _c('tr',{key:transaction.clientRef},[_c('td',[_vm._v(_vm._s(_vm.formatDate(transaction.trx_date)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(transaction.client_invoice_ref))]),_vm._v(" "),_c('td',[_vm._v("\n                      "+_vm._s(transaction.currency)+"\n                      "+_vm._s(parseFloat(transaction.amount || 0).toFixed(2))+"\n                    ")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(transaction.trx_type))]),_vm._v(" "),_c('td',[_c('span',{staticClass:"ac-status-icon",class:transaction.status === 'success'
                            ? 'ac-status-success'
                            : 'ac-status-failed'},[(transaction.direction === 'money_in')?_c('svg',{attrs:{"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"}},[_c('rect',{attrs:{"width":"24","height":"24","rx":"12","fill":"#00C167"}}),_vm._v(" "),_c('path',{attrs:{"d":"M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z","stroke":"white","stroke-width":"1.5","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}}),_vm._v(" "),_c('path',{attrs:{"d":"M8.46973 10.7402L11.9997 14.2602L15.5297 10.7402","stroke":"white","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})]):_c('svg',{attrs:{"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"}},[_c('rect',{attrs:{"x":"24","y":"24","width":"24","height":"24","rx":"12","transform":"rotate(-180 24 24)","fill":"#D80027"}}),_vm._v(" "),_c('path',{attrs:{"d":"M12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2Z","stroke":"white","stroke-width":"1.5","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}}),_vm._v(" "),_c('path',{attrs:{"d":"M15.5303 13.2598L12.0003 9.73977L8.47027 13.2598","stroke":"white","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])])])])}),0)])]),_vm._v(" "),_c('div',{staticClass:"ac-pagination"},[_c('div',{staticClass:"ac-per-page"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.pageSize),expression:"pageSize"}],on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.pageSize=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.onPageSizeChange]}},[_c('option',{attrs:{"value":"10"}},[_vm._v("10")]),_vm._v(" "),_c('option',{attrs:{"value":"25"}},[_vm._v("20")]),_vm._v(" "),_c('option',{attrs:{"value":"50"}},[_vm._v("30")])]),_vm._v(" "),_c('span',[_vm._v("Entries Per Page")])]),_vm._v(" "),_c('div',{staticClass:"ac-pag-btns"},[_c('button',{staticClass:"ac-pag-btn",attrs:{"disabled":_vm.currentPage <= 1},on:{"click":_vm.prevPage}},[_vm._v("\n                  Previous\n                ")]),_vm._v(" "),_c('span',{staticStyle:{"padding":"0 12px","color":"#667085","font-size":"14px","display":"flex","flex-direction":"column","align-items":"center","justify-content":"center"}},[_vm._v("\n                  "+_vm._s(_vm.currentPage)+" / "+_vm._s(_vm.totalPages)+"\n                ")]),_vm._v(" "),_c('button',{staticClass:"ac-pag-btn",attrs:{"disabled":_vm.currentPage >= _vm.totalPages},on:{"click":_vm.nextPage}},[_vm._v("\n                  Next\n                ")])])])])],1)])],1)])])}
__vue__options__.staticRenderFns = []
__vue__options__._scopeId = "data-v-2870a3dd"
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  module.hot.dispose(__vueify_style_dispose__)
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-2870a3dd", __vue__options__)
  } else {
    hotAPI.reload("data-v-2870a3dd", __vue__options__)
  }
})()}